import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCorreos = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 32,
		height: 32,
		rx: 16,
		fill: "#FFCD00"
	}), /* @__PURE__ */ _jsx("g", {
		transform: "translate(7 7) scale(0.063445) translate(5.456 12.856)",
		children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("polygon", {
				points: "187.6,108.8 136.4,108.8 85.3,108.8 85.3,100.3 85.3,91.7 136.4,91.7 187.6,91.7 187.6,100.3",
				fill: "#00457D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M179 27.8c-6.2 0-12 1.8-17.1 4.7-5-2.9-10.8-4.7-17-4.7-3 0-5.9.4-8.7 1.2-2.7-.7-5.4-1.2-8.3-1.2-6.2 0-11.9 1.8-17 4.7-5-2.9-10.9-4.7-17.1-4.7-18.8 0-34.1 15.3-34.1 34.1V79h17.1V61.9c0-9.4 7.6-17.1 17.1-17.1 1.5 0 3 .3 4.4.6-2.7 4.9-4.4 10.4-4.4 16.4v17.1H111v-17c0-9.4 7.6-17.1 17.1-17.1v34.1h17.1V44.8c9.4 0 17.1 7.6 17.1 17.1V79H179V61.9c0-6-1.7-11.5-4.4-16.4 1.4-.4 2.9-.6 4.4-.6 9.4 0 17.1 7.6 17.1 17.1v17.1h17.1V61.9c-.1-18.9-15.3-34.1-34.2-34.1z",
				fill: "#00457D"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				points: "140.1,8 140.1,0 132.7,0 132.7,8 124.7,8 124.7,15.5 132.7,15.5 132.7,23.5 140.1,23.5 140.1,15.5 148.2,15.5 148.2,8",
				fill: "#00457D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M221.7 121.5c0 20.2-7 38.7-18.7 53.3-6.8-30.5-34-53.3-66.5-53.3-20.4 0-38.7 9-51.2 23.2v-23.2H0C0 196.9 61.1 258 136.4 258c75.3 0 136.4-61.1 136.4-136.4h-51.1zM18.4 138.6h49.8v51.2c0 13.3 3.9 25.7 10.5 36.3-32-17.8-54.9-49.8-60.3-87.5zm118 102.3c-28.2 0-51.2-22.9-51.2-51.2s22.9-51.1 51.2-51.1 51.1 22.9 51.1 51c-5.8 4.4-12.1 8-18.9 10.8 1.1-3.4 1.9-6.9 1.9-10.7 0-19.3-15.3-34.1-34.1-34.1s-34.1 15.2-34.1 34.1 15.2 34.1 34.1 34.1c50.7 0 92.8-36.9 100.9-85.2h17.3c-8.2 57.8-58.1 102.3-118.2 102.3zm17.1-51.2c0 9.4-7.6 17-17 17s-17-7.6-17-17 7.6-17 17-17 17 7.6 17 17z",
				fill: "#00457D"
			})
		] }) })
	})]
});
export default SvgCorreos;
